export interface SpinLoaderProps {
  color?: string;
  type?: SpinLoaderTypes;
}

export enum SpinLoaderTypes {
  small = "1",
  medium = "2",
  large = "4",
}
